<template>
  <main class="page-content">
      <!-- Begin Uren's Account Page Area -->
      
        <div class="container-fluid">
          <div class="card">
            <div class="card-header">
              <h1 class="text-center">Profil</h1>
            </div>
            <div class="card-body">
              <form
              @submit.prevent="send"
              @keydown="form.onKeydown($event)"
              enctype="multipart/form-data"
            >
              <div class="row">
                <div class="col-md-9">
                  <div class="box box-primary">
                    <div class="box-body">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="nom"
                              >Nom <span class="text-danger">*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('nom')
                              }"
                              v-model="form.nom"
                              id="nom"
                              name="nom"
                              placeholder="Nom"
                              maxlength="50"
                              required
                            />
                            <has-error :form="form" field="nom"></has-error>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="email"
                              >Email <span class="text-danger">*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('email')
                              }"
                              v-model="form.email"
                              id="email"
                              name="email"
                              placeholder="Email"
                              maxlength="50"
                              required
                            />
                            <has-error :form="form" field="email"></has-error>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="telephone">Téléphone </label>
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('telephone')
                              }"
                              v-model="form.telephone"
                              id="telephone"
                              name="telephone"
                              placeholder="Téléphone"
                              maxlength="15"
                            />
                            <has-error
                              :form="form"
                              field="telephone"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="mobile">Mobile </label>
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('mobile')
                              }"
                              v-model="form.mobile"
                              id="mobile"
                              name="mobile"
                              placeholder="Mobile"
                              maxlength="15"
                            />
                            <has-error :form="form" field="mobile"></has-error>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="adresse">Adresse</label>
                            <textarea
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('adresse')
                              }"
                              v-model="form.adresse"
                              id="adresse"
                              name="adresse"
                              rows="6"
                              placeholder="Adresse"
                              maxlength="100"
                            >
                              Description
                            </textarea>
                            <has-error :form="form" field="adresse"></has-error>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group" style="padding-top: 5px;">
                            <div class="custom-control custom-checkbox mt-4">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                v-model="form.assujetti_tva"
                                id="assujetti_tva"
                                name="assujetti_tva"
                                value="1"
                                disabled
                              />
                              <label
                                class="custom-control-label pt-0"
                                for="assujetti_tva"
                                >Assujetti à la TVA</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="box box-primary">
                    <div class="box-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group mt-4 pt-2">
                            <div class="custom-file">
                              <input
                                type="file"
                                class="custom-file-input"
                                :class="{
                                  'is-invalid': form.errors.has('image')
                                }"
                                id="image"
                                name="image"
                                accept=".png, .jpg, .jpeg"
                                @change="onFileChange"
                              />
                              <label
                                class="custom-file-label"
                                :class="{ selected: selected }"
                                for="image"
                                data-browse="Choisir"
                              >
                                {{ fileName }}
                              </label>
                              <has-error :form="form" field="image"></has-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="" id="divpreview">
                            <img
                              v-if="url"
                              id="preview"
                              :src="url"
                              class="mx-auto d-block"
                              style="max-width: 100%; max-height:200px;"
                              alt="Image"
                            />
                            <img
                              v-else
                              id="previewNo"
                              :src="URL + '/avatars/no_avatar/no_avatar.png'"
                              class="mx-auto d-block"
                              style="max-width: 100%; max-height:200px;"
                              alt="Image"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row mt-2 mb-n1">
                        <div class="col-md-12">
                          <div class="info">
                            <div
                              class="text-primary text-center text-uppercase mb-2 display-5"
                            >
                              <span>
                                <a
                                  href="#"
                                  @click="onClearImage"
                                  v-if="url"
                                  class="btn btn-danger btn-sm"
                                  >Effacer</a
                                >
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-n1">
                      <div class="col-md-12">
                        <div class="list-group">
                          <span class="list-group-item"
                            ><i class="fa fa-calendar"></i> Inscrit depuis
                            <span
                              class="badge badge-pill badge-primary pull-right"
                            >
                              <span v-if="form.created_at">
                                {{ form.created_at }}
                              </span>
                            </span></span
                          >
                          <span class="list-group-item"
                            ><i class="fa fa-user-secret"></i> Droit
                            <span
                              class="badge badge-pill badge-warning pull-right"
                            >
                              {{ form.droit }}</span
                            ></span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-center">
                  <ButtonLoader
                    :busy="form.busy"
                    type="submit"
                    classes="btn-save"
                    loadText="Traitement en cours..."
                    Text="Enregistrer"
                  ></ButtonLoader>
                </div>
              </div>
            </form>
            </div>
          </div>
        </div>
      <!-- Uren's Account Page Area End Here -->
    </main>
</template>

<script>
  import * as services from "./service/services";
  import Form from "vform";
  import constant from "@/constant";
  import { objectToFormData } from 'object-to-formdata';
export default {
  name: "MyAccount",
  components: {},
  data() {
    return{
      form: new Form({
          nom: "",
          email: "",
          telephone: "",
          mobile: "",
          adresse: "",
          assujetti_tva: false,
          role: "",
          image: "",
          created_at: "",
          clearImage: false
      }),

      URL: constant.URL_FILE,

      fileName: "",
      selected: false,
      url: "",

      title: "Profil"
    }
  },
  methods: {
        onClearImage: function(){
            this.form.image = "";
            this.url = "";
            this.fileName = "";
            this.selected = false;
            this.form.clearImage = true;
        },
        onFileChange: function(e){
            const file = e.target.files[0];
            this.form.image = file;
            this.url = URL.createObjectURL(file);

            this.fileName = file.name;
            this.selected = true;
            this.form.clearImage = false;
        },
        async send() {
            await this.form
                .post(services.PROFIL_UPDATE,{
                    transformRequest: [
                        function (data, headers) {
                            return objectToFormData(data)
                        }
                    ]
                })
                .then(data => {
                    this.form.image = "";
                    this.selected = false;

                    this.$store.dispatch('auth/updateUser', {
                        userp: data.data.client,
                    });

                    this.$swal({
                        position: 'top-end',
                        icon: data.data.type,
                        text: data.data.message,
                        showConfirmButton: false,
                        timer: window.Timer
                    });

                    this.initialise();

                }).catch((err) => {

                })
        },
        initialise(){
            axios.get(services.GET_PROFIL)
                .then((resp) => {

                    this.form.nom = resp.data.client.nom;
                    this.form.adresse = resp.data.client.adresse;
                    this.form.email = resp.data.client.email;
                    this.form.telephone = resp.data.client.telephone;
                    this.form.mobile = resp.data.client.mobile;
                    this.form.assujetti_tva = resp.data.client.assujetti_tva;

                    this.form.created_at = this.convertDate(resp.data.client.created_at, null, true, false);

                    this.form.droit = resp.data.role;

                    this.url = resp.data.client.image ? this.URL + "/avatars/" + resp.data.client.image : "";

                }).catch();
        }
    },
    mounted: function () {

       this.initialise();

    }
}
</script>

<style scoped>
  .btn-save {
    background-color: #caaa73;
    margin: 1rem 0;
    padding: .7rem 1rem;
    border-radius: 5px;
    min-width: 30%;
    font-size: 1.2rem;
    transition: all .5s ease;
  }
   .btn-save:hover {
     transform: scale(1.01);
     background-color: #917545;
     color: #fff;
   }
   .btn-save:focus {
      outline: none;
   }
   .btn-save:active {
     transform: scale(0.95);
   }
   .form-control:focus {
     border-color: #f1d198;
     box-shadow: 0 0 0 0.2rem rgba(88, 69, 36, 0.25); 
   }
</style>
